var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFilter24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 6.02112C6.94772 6.02112 6.5 6.46883 6.5 7.02112V9.9796C6.5 10.1148 6.55471 10.2442 6.65168 10.3383L10.3571 13.9365V18.6325C10.3571 18.7021 10.3815 18.7719 10.4299 18.8303C10.5515 18.977 10.7849 19.0058 10.9441 18.8829L13.5155 16.8978C13.5994 16.833 13.6429 16.7399 13.6429 16.6474V13.9365L17.3483 10.3383C17.4453 10.2442 17.5 10.1148 17.5 9.9796V7.02112C17.5 6.46883 17.0523 6.02112 16.5 6.02112H7.5ZM5.5 7.02112C5.5 5.91655 6.39543 5.02112 7.5 5.02112H16.5C17.6046 5.02112 18.5 5.91655 18.5 7.02112V9.9796C18.5 10.3851 18.3359 10.7733 18.045 11.0557L14.6429 14.3594V16.6474C14.6429 17.0577 14.4495 17.4401 14.1266 17.6893L11.5552 19.6745C10.9749 20.1224 10.1296 20.0353 9.65984 19.4682C9.46516 19.2332 9.35714 18.9386 9.35714 18.6325V14.3594L5.95503 11.0557C5.66414 10.7733 5.5 10.3851 5.5 9.9796V7.02112Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter24);
export default __webpack_public_path__ + "static/media/icon-filter-24.bfa203dc.svg";
export { ForwardRef as ReactComponent };